import 'react-toastify/dist/ReactToastify.css';
import Highcharts from 'highcharts';
import HighchartsExportData from 'highcharts/modules/export-data';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsReact from 'highcharts-react-official';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import { ToastContainer, toast } from 'react-toastify';
import {
  Card,
  CardBody,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
} from 'reactstrap';

// import SummaryTable from "./Unitlist";
// import SummaryTableOverall from "./summarytable";

HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

const UnitQc = () => {
  document.title = 'Linc Quality Hub';

  const toggleMilestoneDropdown = () => {
    setMilestoneDropdownOpen((prev) => !prev);
  };

  // State for dropdowns and selected items
  const [universityDropdownOpen, setUniversityDropdownOpen] = useState(false);
  const [programDropdownOpen, setProgramDropdownOpen] = useState(false);
  const [timelineDropdownOpen, setTimelineDropdownOpen] = useState(false);
  const [termDropdownOpen, setTermDropdownOpen] = useState(false);
  const [selectedUniversities, setSelectedUniversities] = useState(new Set());
  const [appliedUniversities, setAppliedUniversities] = useState(new Set());
  const [appliedTerms, setAppliedTerms] = useState(new Set()); // New state for applied terms
  const [timelineYears, setTimelineYears] = useState([]);
  const [timelineTerms, setTimelineTerms] = useState([]);
  const [selectedTimelines, setSelectedTimelines] = useState(new Set());
  const [appliedTimelines, setAppliedTimelines] = useState(new Set());
  const [selectedPrograms, setSelectedPrograms] = useState(new Set());
  const [appliedPrograms, setAppliedPrograms] = useState(new Set()); // New state for applied terms
  const [unitData, setUnitData] = useState(null);
  const [tableData, setTableFData] = useState(null);
  const [summarytabledata, setSummary] = useState(null);
  const [loading, setLoading] = useState(true); // New loading state
  const [selectedTerms, setSelectedTerms] = useState(new Set()); // New state for selected terms
  const [programs, setPrograms] = useState([]);
  const [milestoneDropdownOpen, setMilestoneDropdownOpen] = useState(false);
  const [selectedMilestones, setSelectedMilestones] = useState(new Set());
  const [appliedmilestone, setAppliedmileStone] = useState(new Set());
  const [milestone, setMilestone] = useState([]);
  const [timelineMilestone, setTimelineMilestone] = useState([]);
  const [milestonetypeDropdownOpen, setMilestonetypeDropdownOpen] =
    useState(false);
  const [selectedMilestonestype, setSelectedMilestonestype] = useState(
    new Set(),
  );
  const [appliedmilestonetype, setAppliedMilestonetype] = useState(new Set()); // New state for applied terms
  const [timelineMilestonetype, setTimelineMilestonetype] = useState([]);

  // // console.log("unitDatausestate", unitData)

  // State for fetched data
  const [universities, setUniversities] = useState([]);

  //search option
  const [universitySearch, setUniversitySearch] = useState('');
  const [programSearch, setProgramSearch] = useState('');
  const [timelineSearch, setTimelineSearch] = useState('');
  const [termSearch, setTermSearch] = useState('');
  const [milestoneTypeSearch, setMilestoneTypeSearch] = useState('');
  const [milestoneSearch, setMilestoneSearch] = useState('');
  const handleSearchChange = (e, type) => {
    const value = e.target.value;
    switch (type) {
      case 'university':
        setUniversitySearch(value);
        break;
      case 'program':
        setProgramSearch(value);
        break;
      case 'timeline':
        setTimelineSearch(value);
        break;
      case 'term':
        setTermSearch(value);
        break;
      case 'milestoneType':
        setMilestoneTypeSearch(value);
        break;
      case 'milestone':
        setMilestoneSearch(value);
        break;
      default:
        break;
    }
  };

  const filterUniversities = (universitySearch) => {
    return universities.filter((u) =>
      u.university_name.toLowerCase().includes(universitySearch.toLowerCase()),
    );
  };

  const filterPrograms = (programSearch) => {
    return programs.filter(([id, name]) =>
      name.toLowerCase().includes(programSearch.toLowerCase()),
    );
  };

  const filterTimeline = (timelineSearch) => {
    return timelineYears.filter((year) => year.includes(timelineSearch));
  };

  const filterTerms = (termSearch) => {
    return timelineTerms.filter((term) =>
      term.toLowerCase().includes(termSearch.toLowerCase()),
    );
  };
  const filterMilestoneTypes = (search) => {
    return timelineMilestonetype.filter((type) =>
      type.toLowerCase().includes(search.toLowerCase()),
    );
  };

  const filterMilestones = (search) => {
    return timelineMilestone.filter((milestone) =>
      milestone.toString().includes(search),
    );
  };

  const toggleUniversityDropdown = () => {
    setUniversityDropdownOpen((prev) => !prev);
  };

  const toggleTimelineDropdown = () => {
    setTimelineDropdownOpen((prev) => !prev);
  };
  const toggleProgramDropdown = () => {
    setProgramDropdownOpen((prev) => !prev);
  };
  const toggleTermDropdown = () => {
    setTermDropdownOpen((prev) => !prev); // Toggle term dropdown
  };

  const toggleMilestonetypeDropdown = () =>
    setMilestonetypeDropdownOpen((prev) => !prev);

  const handleSelectItem = (item, selectedSet, setter, toggleDropdown) => {
    const newSelection = new Set(selectedSet);
    if (item.id === 1) {
      // "All" option
      if (newSelection.has(item.id)) {
        newSelection.clear();
        fetchDataYear();
      } else {
        newSelection.clear();
        newSelection.add(item.id);
        universities.forEach((i) => newSelection.add(i.id));
      }
    } else {
      if (newSelection.has(item.id)) {
        newSelection.delete(item.id);
      } else {
        newSelection.add(item.id);
      }
    }
    setter(newSelection);
    toggleDropdown();
  };

  const isItemSelected = (itemId, selectedSet) => selectedSet.has(itemId);
  const isTermSelected = (selectedTerm) => selectedTerms.has(selectedTerm);
  const handleSelectItemTimeLine = (selectedYear) => {
    const newSelection = new Set(selectedTimelines);
    if (newSelection.has(selectedYear)) {
      newSelection.delete(selectedYear);
    } else {
      newSelection.add(selectedYear);
    }
    setSelectedTimelines(newSelection);
  };
  const isTimelineSelected = (selectedYear) =>
    selectedTimelines.has(selectedYear);
  const isProgramsSelected = (selectedProgram) =>
    selectedPrograms.has(selectedProgram);
  const ismilestoneSelected = (selectedMilestone) =>
    selectedMilestones.has(selectedMilestone);
  const ismilestonetypemSelected = (selectedMiletype) =>
    selectedMilestonestype.has(selectedMiletype);

  const handleSelectItemPrograms = (selectedProgram) => {
    const newSelection = new Set(selectedPrograms);
    if (newSelection.has(selectedProgram)) {
      newSelection.delete(selectedProgram);
    } else {
      newSelection.add(selectedProgram);
    }
    setSelectedPrograms(newSelection);
  };

  const handleSelectItem1 = (item, selectedSet, setter, toggleDropdown) => {
    const newSelection = new Set();

    // Always add the selected item (ID) to the selection set
    newSelection.add(item.id);

    setter(newSelection); // Update the state with the new single selection
    toggleDropdown(); // Optionally toggle the dropdown visibility
  };

  const handleSelectItemMilestone = (selectedMilestone) => {
    const newSelection = new Set(selectedMilestones);
    if (newSelection.has(selectedMilestone)) {
      newSelection.delete(selectedMilestone);
    } else {
      newSelection.add(selectedMilestone);
    }
    setSelectedMilestones(newSelection);
  };

  const handleApply = () => {
    if (selectedUniversities.size === 0) {
      toast.error('Please choose a university.');
      return;
    }
    if (selectedPrograms.size === 0) {
      toast.error('Please choose a program.');
      return;
    }
    if (selectedTimelines.size === 0) {
      toast.error('Please choose a year.');
      return;
    }
    if (selectedTerms.size === 0) {
      toast.error('Please choose a study period.');
      return;
    }

    // Apply selections
    setAppliedUniversities(new Set(selectedUniversities));
    setAppliedTimelines(new Set(selectedTimelines));
    setAppliedTerms(new Set(selectedTerms));
    setAppliedPrograms(new Set(selectedPrograms));
    setAppliedmileStone(new Set(selectedMilestones));
    setAppliedMilestonetype(new Set(selectedMilestonestype));

    // Close all dropdowns
    setUniversityDropdownOpen(false);
    setTimelineDropdownOpen(false);
    setTermDropdownOpen(false);
    setMilestonetypeDropdownOpen(false);
    setMilestoneDropdownOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          process.env.REACT_APP_API_BASE_URL + 'filter/',
        );
        setUniversities(response.universities || []); // Ensure we set to an empty array if undefined
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (selectedUniversities && selectedUniversities.size > 0) {
      fetchDataProgram();
    }
  }, [selectedUniversities]);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0
    ) {
      fetchDataYear();
    }
  }, [selectedUniversities, selectedPrograms]);

  const fetchDataProgram = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        mode: 'metrics',
        sub_mode: 'program',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
      );
      setPrograms(unitResponse.program || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };

  const fetchDataYear = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        mode: 'metrics',
        sub_mode: 'year',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
      );
      setTimelineYears(unitResponse.year || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };
  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedTimelines.size > 0
    ) {
      fetchDataTerm();
    }
  }, [selectedUniversities, selectedTimelines]);

  const fetchDataTerm = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        mode: 'teacher_report',
        sub_mode: 'term',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
      );
      // setTimelineYears(unitResponse.year || []);
      setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0 &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0
    ) {
      fetchDataMileStonetype();
    }
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
  ]);

  const fetchDataMileStonetype = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,

        mode: 'teacher_qc',
        sub_mode: 'milestone_type',
        //  milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
      );
      // setTimelineYears(unitResponse.year || []);
      setTimelineMilestonetype(unitResponse.milestone_types || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };
  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0 &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0 &&
      selectedMilestonestype.size > 0
    ) {
      fetchDataMileStone();
    }
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
    selectedMilestonestype,
  ]);
  const fetchDataMileStone = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
        milestone_type:
          selectedMilestonestype.size > 0
            ? Array.from(selectedMilestonestype)[0]
            : null,

        mode: 'unit_qc',
        sub_mode: 'milestone',
        //  milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
      );
      // setTimelineYears(unitResponse.year || []);
      setTimelineMilestone(unitResponse.milestone || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      (appliedUniversities && appliedUniversities.size > 0,
      appliedTimelines && appliedTimelines.size > 0,
      appliedTerms && appliedTerms.size > 0)
    ) {
      fetchDataUnitqc();
    }
  }, [
    appliedUniversities,
    appliedTimelines,
    appliedTerms,
    appliedPrograms,
    appliedmilestone,
  ]);

  const fetchDataUnitqc = async () => {
    try {
      setLoading(true);

      const payload = {
        university:
          appliedUniversities.size > 0 ? Array.from(appliedUniversities) : null,
        year: appliedTimelines.size > 0 ? Array.from(appliedTimelines) : null,
        term: appliedTerms.size > 0 ? Array.from(appliedTerms) : null,
        program: appliedPrograms.size > 0 ? Array.from(appliedPrograms) : null,
        // milestone_type: "completion",
        milestone:
          appliedmilestone.size > 0 ? Array.from(appliedmilestone) : null,
        milestone_type:
          appliedmilestonetype.size > 0
            ? Array.from(appliedmilestonetype)[0]
            : null,
        sub_mode: 'milestone',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'unit_qc/',
        payload,
      );
      setUnitData(unitResponse.card_data);
      setTableFData(unitResponse.unit_metrics_report);
      setSummary(unitResponse.summary);

      // console.log("unit data", unitResponse);
    } catch (error) {
      // console.log('error fetching unit qc', error);
    } finally {
      setLoading(false);
    }
  };

  // const prepareCsvData = () => {
  //   const titles = [
  //     "Metric",
  //     "Value"
  //   ];

  //   if (unitData && unitData.length > 0) {
  //     const data = [
  //       ["Weak Students (%)", unitData[0].overall_percentage_weak_students || '0%'],
  //       ["Phone Engaged (%)", unitData[0].overall_phone_engaged || '0%'],
  //       ["Engaged Students (%)", unitData[0].overall_student_engaged || '0%'],
  //       ["Avg Call Duration/Student", unitData[0].overall_average_call_time_per_student || '0'],
  //       ["% Red Flags (Total Calls)", unitData[0].overall_total_flags_count || '0%'],
  //       ["Teachers with Compliance Flags", unitData[0].overall_total_teachers_count_red_flags || '0'],
  //       ["LF Responsiveness Total (Milestone Week)", unitData[0].overall_message_responsiveness || '0'],
  //       ["Average Assessment Grading Quality Score", unitData[0].overall_average_assessment_grading_quality || '0']
  //     ];

  //     return [titles, ...data]; // Combine titles with data
  //   }

  //   // If there's no data, return titles with empty values
  //   return [titles,
  //     ["Weak Students (%)", '0'],
  //     ["Phone Engaged (%)", '0'],
  //     ["Engaged Students (%)", '0'],
  //     ["Avg Call Duration/Student", '0'],
  //     ["% Red Flags (Total Calls)", '0'],
  //     ["Teachers with Compliance Flags", '0'],
  //     ["LF Responsiveness Total (Milestone Week)", '0'],
  //     ["Average Assessment Grading Quality Score", '0']
  //   ];
  // };

  // Use the CSVLink with a custom CSV generation to include BOM
  // const csvData = prepareCsvData();
  // const csvWithBom = "\uFEFF" + csvData.map(row => row.join(",")).join("\n")

  // sticky filter bar
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY; // Current scroll position
      const threshold = 100; // Adjust this value as needed
      setIsSticky(scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Helper function to update selected filters
  const handleSelectionChange = (type, value) => {
    const updatedSet = new Set(type);
    if (updatedSet.has(value)) {
      updatedSet.delete(value);
    } else {
      updatedSet.add(value);
    }
    return updatedSet;
  };

  const [slideIndex, setSlideIndex] = useState(0);
  const slideWidth = 300; // Adjust this based on your filter tag size

  const [showScrollButtons, setShowScrollButtons] = useState(false);

  const checkOverflow = () => {
    if (filterSummaryRef.current) {
      setShowScrollButtons(
        filterSummaryRef.current.scrollWidth >
          filterSummaryRef.current.clientWidth,
      );
    }
  };
  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow); // Recheck on window resize
    return () => window.removeEventListener('resize', checkOverflow);
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
  ]);

  // Function to handle the left scroll button click
  const handleLeftClick = () => {
    if (filterSummaryRef.current) {
      const newScrollLeft = Math.max(
        filterSummaryRef.current.scrollLeft - 200,
        0,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  // Function to handle the right scroll button click
  const handleRightClick = () => {
    if (filterSummaryRef.current) {
      const maxScrollLeft =
        filterSummaryRef.current.scrollWidth -
        filterSummaryRef.current.clientWidth;
      const newScrollLeft = Math.min(
        filterSummaryRef.current.scrollLeft + 200,
        maxScrollLeft,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const filterSummaryRef = useRef(null);

  // Start dragging (onMouseDown)
  const startDrag = (e) => {
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    setIsDragging(true);
    setStartX(clientX);
    setScrollLeft(filterSummaryRef.current.scrollLeft);
    filterSummaryRef.current.style.cursor = 'grabbing'; // Change the cursor for desktop
    document.body.style.userSelect = 'none'; // Disable text selection globally
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const distance = clientX - startX;
    filterSummaryRef.current.scrollLeft = scrollLeft - distance;
  };

  const stopDrag = () => {
    setIsDragging(false);
    filterSummaryRef.current.style.cursor = 'grab';
    document.body.style.userSelect = ''; // Re-enable text selection globally
  };

  const removeUniversity = (universityId) => {
    setSelectedUniversities((prev) => {
      const newSet = new Set(prev);
      newSet.delete(universityId);
      return newSet;
    });
  };

  // Function to remove a program from the selected set
  const removeProgram = (programId) => {
    setSelectedPrograms((prev) => {
      const newSet = new Set(prev);
      newSet.delete(programId);
      return newSet;
    });
  };

  // Function to remove a timeline from the selected set
  const removeTimeline = (year) => {
    setSelectedTimelines((prev) => {
      const newSet = new Set(prev);
      newSet.delete(year);
      return newSet;
    });
  };

  // Function to remove a term from the selected set
  const removeTerm = (term) => {
    setSelectedTerms((prev) => {
      const newSet = new Set(prev);
      newSet.delete(term);
      return newSet;
    });
  };
  //fileter deleted selection
  const hasSelections =
    selectedUniversities.size > 0 ||
    selectedPrograms.size > 0 ||
    selectedTimelines.size > 0 ||
    selectedTerms.size > 0 ||
    selectedMilestonestype.size > 0 ||
    selectedMilestones.size > 0;

  const clearAllSelections = () => {
    setSelectedUniversities(new Set());
    setSelectedPrograms(new Set());
    setSelectedTimelines(new Set());
    setSelectedTerms(new Set());
    setSelectedMilestonestype(new Set());
    setSelectedMilestones(new Set());
  };

  return (
    <React.Fragment>
      <div className="page-content px-0">
        <Container fluid={true}>
          <div className={`top-filter ${isSticky ? 'sticky-filter' : ''}`}>
            <div className="d-md-flex justify-content-between align-items-center mb-2">
              <div className="tab-tp-title">
                <h3 className="bold">Study Period Report</h3>
              </div>
            </div>

            {/* normal nav filter show */}
          </div>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  );
};

export default UnitQc;
